import { useQuery } from 'react-query';
import { HttpService } from 'core/services/http';

export const useCVFiles = () => {
  return useQuery(
    ['cvfiles'],
    async () => {
      const service = new HttpService();
      const response = await service.get('/job/cv/cvfile/', null);
      // Normalize to array
      if (Array.isArray(response)) return response;
      if (response?.results) return response.results;
      return [];
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60000,
    }
  );
}; 